export const getDefaultState = () => {
  return {
    dvirSearchResults: [],
    dvirsCount: null
  };
};

export default {
  ...getDefaultState()
};
